// test147
(147 && 0);
